import Container from './DesktopBatchActionWrapper.container';
import DesktopBatchActionWrapper from './DesktopBatchActionWrapper';

export default Container(DesktopBatchActionWrapper);
